import { Rent } from '@model/rent';
import { Notice } from '@model/notice';
import { Tenant } from '@model/tenant';
import { Payment } from '@model/payment';
import { Penality } from '@model/penality';
import { Contract } from '@model/contract';
import { Invoice } from '@model/invoice';
import { Inventory } from '@model/inventory';
import { environment } from '@env/environment';
import { Terminate } from '@model/terminate';
import { Globals } from '@theme/utils/globals';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ShortContract } from '@model/short-contract';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from 'ngx-permissions';
import { RentService } from '@service/rent/rent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantService } from '@service/tenant/tenant.service';
import { FilterService } from '@service/filter/filter.service';
import { NoticeService } from '@service/notice/notice.service';
import { InvoiceService } from '@service/invoice/invoice.service';
import { PaymentService } from '@service/payment/payment.service';
import { UploaderService } from '@service/uploader/uploader.service';
import { PenalityService } from '@service/penality/penality.service';
import { ContractService } from '@service/contract/contract.service';
import { InventoryService } from '@service/inventory/inventory.service';
import { TenantAddComponent } from '../tenant-add/tenant-add.component';
import { TenantWalletComponent } from '../tenant-wallet/tenant-wallet.component';
import { TerminateService } from '@service/terminate/terminate.service';
import { ShortContractService } from '@service/short-contract/short-contract.service';
import { ActivityService } from '@service/activity/activity.service';
import { RendService } from '@service/rdv/rend.service';

@Component({
  selector: 'app-tenant-show',
  templateUrl: './tenant-show.component.html',
  styleUrls: ['./tenant-show.component.scss']
})
export class TenantShowComponent implements OnInit {
  publicLink = environment.publicUrl;
  public activeTab: string = 'LOCATAIRE';
  global = { country: Globals.country, device: Globals.device }
  userSession = Globals.user
  tenant: Tenant;
  locataire: boolean = false;
  typeI: string = '';
  terminates: Terminate[] = [];
  contracts: Contract[] = [];
  shortContracts: ShortContract[] = [];
  inventories: Inventory[] = [];
  invoices: Invoice[] = [];
  autres: Invoice[] = [];
  invoicesTerminate: Invoice[] = [];
  shortInvoices: Invoice[] = [];
  rents: Rent[] = [];
  penalities: Penality[] = [];
  notices: Notice[] = [];
  payments: Payment[] = [];
  publicUrl = environment.publicUrl;
  type: string = 'LOCATAIRE';
  etatRow = [];
  typeRow = [
    { label: 'Locataire', value: 'LOCATAIRE' },
    { label: 'Contrat', value: 'CONTRAT' },
    {label: 'Contrat à court terme', value: 'SHORT_CONTRACT'},
    { label: 'Résiliation', value: 'RESILIATION' },
    { label: 'État des lieux', value: 'ETAT' },
    { label: 'Loyer', value: 'LOYER' },
    { label: 'Facture', value: 'FACTURE' },
    { label: 'Autres factures', value: 'AUTRE' },
    { label: 'Pénalité', value: 'PENALITE' },
    { label: 'Avis échéance', value: 'AVIS' },
    { label: 'Paiement', value: 'PAIEMENT' },
    { label: 'Résiliation', value: 'FACTRESILIATION' },
    { label: 'Facture court terme', value: 'COURT-TERME'}
  ];
  categorieRow = [
    { label: 'Particulier', value: 'PARTICULIER' },
    { label: 'Entreprise', value: 'ENTREPRISE' }
  ];
  minTitle: string = "Montant MIN"
  userTitle: string = "Crée par"
  maxTitle: string = "Montant MAX"
  categorieTitle: string = "Type de locataire"
  etatTitle: string = "Disponibilité ?"
  file: any;
  rdvs = []
  notes = []

  nameTitle: string = "Nom / Raison sociale"
  name: boolean = true;
  nameType = 'TEXT';
  nameClass= 'Tenant';
  nameNamespace= 'Client';
  nameGroups= 'tenant';

  autreTitle = "Bailleur";
  autre: boolean = true;
  autreType = 'ENTITY';
  autreClass= 'Owner';
  autreNamespace= 'Client';
  autreGroups= 'owner';

  bienTitle: string = "Nom du bien"
  bien: boolean = true
  bienType = 'ENTITY';
  bienClass= 'House';
  bienNamespace= 'Client';
  bienGroups= 'house';

  libelleTitle: string = "N° Contrat"
  libelle: boolean = false
  libelleType = 'TEXT';
  libelleClass= 'House';
  libelleNamespace= 'Client';
  libelleGroups= 'house';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private rentService: RentService,
    private uploader: UploaderService,
    private noticeService: NoticeService,
    private filterService: FilterService,
    private tenantService: TenantService,
    private paymentService: PaymentService,
    private invoiceService: InvoiceService,
    private contractService: ContractService,
    private penalityService: PenalityService,
    private inventoryService: InventoryService,
    private terminateService: TerminateService,
    private activityService: ActivityService,
    private rdvService: RendService,
    private permissionsService: NgxPermissionsService,
    private shortContractService: ShortContractService
  ) {
    this.tenant = this.tenantService.getTenant();
    this.onChangeLoad(this.type);
    const permission = JSON.parse(localStorage.getItem('permission-zen')) ? JSON.parse(localStorage.getItem('permission-zen')) : [];
    this.permissionsService.loadPermissions(permission);
  }

  ngOnInit(): void {
  }

  onFilter($event) {
    this.invoices = [];
    this.rents = [];
    this.penalities = [];
    this.inventories = [];
    this.contracts = [];
    this.autres = [];
    this.notices = [];
    this.payments = [];
    this.terminates = [];
    this.shortContracts = [];
    this.shortInvoices = [];
    this.invoicesTerminate = [];
    $event.type = this.activeTab;
    this.filterService.search($event, 'tenant', this.tenant.uuid).subscribe(
      res => {
        if (this.activeTab === 'CONTRAT') {
          return this.contracts = res;
        } else if (this.activeTab === 'SHORT_CONTRACT') {
          return this.shortContracts = res;
        } else if (this.activeTab === 'ETAT') {
          return this.inventories = res;
        } else if (this.activeTab === 'ENTREE') {
          return this.invoices = res;
        } else if (this.activeTab === 'AUTRE') {
          return this.autres = res;
        } else if (this.activeTab === 'LOYER') {
          return this.rents = res;
        } else if (this.activeTab === 'PENALITE') {
          return this.penalities = res;
        } else if (this.activeTab === 'PAIEMENT') {
          return this.payments = res;
        } else if (this.activeTab === 'AVIS') {
          return this.notices = res;
        } else if (this.activeTab === 'RESILIATION') {
          return this.terminates = res;
        } else if (this.activeTab === 'FACTRESILIATION') {
          return this.invoicesTerminate = res;
        } else if (this.activeTab === 'COURT-TERME') {
          return this.shortInvoices = res;
        }
      }, err => { })
  }
  onChangeLoad(type): void {
    this.activeTab = type;
    if (type === 'LOCATAIRE') {
      if (!this.tenant) {
        this.tenantService.getSingle(this.route.snapshot.params.id).subscribe((res: any) => {
          return this.tenant = res
        });
      }
    } else if (type === 'CONTRAT') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.etatTitle = 'État'
      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.typeRow = [
        { label: 'Contrat', value: 'CONTRAT' },
        { label: 'Résiliation', value: 'RESILIATION' },
        { label: 'Court terme', value: 'SHORT_CONTRACT' },
      ];
      this.contractService.getList(this.tenant.uuid, null).subscribe((res) => {
        return this.contracts = res;
      }, error => { }
      );
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Actif', value: 'ACTIF' },
        { label: 'Reservé', value: 'RESERVE' },
        { label: 'Résilié', value: 'RESILIE' }
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = [
        { label: 'Habitation', value: 'HABITATION' },
        { label: 'Commercial', value: 'COMMERCIAL' }
      ]
    } else if (type === 'SHORT_CONTRACT') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeRow = [
        { label: 'Court terme', value: 'SHORT_CONTRACT' },
        { label: 'Contrat', value: 'CONTRAT' },
        { label: 'Résiliation', value: 'RESILIATION' },
      ];
      this.shortContractService.getList(this.tenant.uuid, null).subscribe((res) => {
        return this.shortContracts = res;
      }, error => { }
      );
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Actif', value: 'ACTIF' },
        { label: 'Reservé', value: 'RESERVE' },
        { label: 'Résilié', value: 'RESILIE' }
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = [
        { label: 'Habitation', value: 'HABITATION' },
        { label: 'Commercial', value: 'COMMERCIAL' }
      ]
    } else if (type === 'RESILIATION') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeRow = [
        { label: 'Résiliation', value: 'RESILIATION' },
        { label: 'Contrat', value: 'CONTRAT' },
        { label: 'Court terme', value: 'SHORT_CONTRACT' },
      ];
      this.terminateService.getList(this.tenant.uuid).subscribe((res) => {
        return this.terminates = res;
      }, error => { }
      );
    } else if (type === 'ETAT') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeRow = [{ label: 'ETAT', value: 'ETAT' }];
      this.inventoryService.getList(this.tenant.uuid).subscribe((res) => {
        return this.inventories = res;
      }, error => { }
      );
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'En attente', value: 'ATTENTE' },
        { label: 'Validé', value: 'VALIDE' }
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = [
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Sortie', value: 'SORTIE' }
      ]
    } else if (type === 'AUTRE') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeI = 'autre'
      this.invoiceService.getList(this.tenant.uuid, type, null).subscribe((res) => {
        return this.autres = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Résiliation', value: 'FACTRESILIATION' },
        { label: 'Facture court terme', value: 'COURT-TERME'},
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieRow = []
    } else if (type === 'ENTREE') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.invoiceService.getList(this.tenant.uuid, type, null).subscribe((res) => {
        return this.invoices = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Résiliation', value: 'FACTRESILIATION' },
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Facture court terme', value: 'COURT-TERME'},
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieRow = []
    } else if (type === 'FACTRESILIATION') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeI = 'resiliation'
      this.invoiceService.getList(this.tenant.uuid, 'RESILIATION', null).subscribe((res) => {
        return this.invoicesTerminate = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Résiliation', value: 'FACTRESILIATION' },
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Facture court terme', value: 'COURT-TERME'},
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieRow = []
    }  else if (type === 'COURT-TERME') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeI = 'factureCourtTerme'
      this.invoiceService.getList(this.tenant.uuid, 'COURT-TERME', null).subscribe((res) => {
        return this.shortInvoices = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Facture court terme', value: 'COURT-TERME'},
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Résiliation', value: 'FACTRESILIATION' },
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieRow = []
    } else if (type === 'PENALITE') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleurs";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.penalityService.getList(this.tenant.uuid).subscribe((res) => {
        return this.penalities = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Résiliation', value: 'FACTRESILIATION' },
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Facture court terme', value: 'SHORT_CONTRACT'},
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieRow = []
    } else if (type === 'LOYER') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.rentService.getList(this.tenant.uuid).subscribe((res) => {
        return this.rents = res;
      }, error => { }
      );
      this.typeRow = [
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Entrée', value: 'ENTREE' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: 'Autre', value: 'AUTRE' },
        { label: 'Résiliation', value: 'FACTRESILIATION' },
        { label: 'Facture court terme', value: 'SHORT_CONTRACT'},
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Impayé', value: 'IMPAYE' },
        { label: 'Attente', value: 'ATTENTE' },
        { label: 'En cours', value: 'EN COURS' },
        { label: 'Soldé', value: 'SOLDE' }
      ]
      this.categorieTitle = 'Type'
      this.categorieRow = [
        { label: 'Loyer', value: 'LOYER' },
        { label: 'Avance', value: 'AVANCE' }
      ]
    } else if (type === 'AVIS') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.noticeService.getList(this.tenant.uuid).subscribe((res) => {
        return this.notices = res;
      }, error => { }
      );
      this.typeRow = [{ label: 'AVIS', value: 'AVIS' }];
      this.etatRow = []
      this.categorieRow = []
    } else if (type === 'PAIEMENT') {
      this.name = false;
      this.nameTitle = 'Locataire'
      this.nameType = 'ENTITY';
      this.nameClass= 'Tenant';
      this.nameNamespace= 'Client';
      this.nameGroups= 'tenant';

      this.bien = true;
      this.bienTitle = 'Nom du bien';
      this.bienType = 'ENTITY';
      this.bienClass= 'House';
      this.bienNamespace= 'Client';
      this.bienGroups= 'house';

      this.autreTitle = "Bailleur";
      this.autre = true;
      this.autreType = 'ENTITY';
      this.autreClass= 'Owner';
      this.autreNamespace= 'Client';
      this.autreGroups= 'owner';

      this.typeRow = [{ label: 'PAIEMENT', value: 'PAIEMENT' }];
      this.paymentService.getList(this.tenant.uuid).subscribe((res) => {
        return this.payments = res;
      }, error => { }
      );
      this.etatTitle = 'État'
      this.etatRow = [
        { label: 'Validé', value: 'VALIDE' },
        { label: 'En attente de validation', value: 'INVALIDE' }
      ]
      this.categorieTitle = 'Type facture'
      this.categorieRow = [
        { label: 'Loyer', value: 'LOYER' },
        { label: "Facture d'entrée", value: 'ENTREE' },
        { label: 'Pénalité', value: 'PENALITE' },
        { label: "Autres factures", value: 'AUTRE' },
      ]
    } else if (type === 'NOTE_INTERNE'){
      this.activityService.getList(null, null, null, this.tenant.uuid).subscribe((res: any) => {
        return this.notes = res
      })
      this.rdvService.getList(null, null, null, this.tenant.uuid).subscribe((res: any) => {
        return this.rdvs = res
      })
    }
  }
  onEditWallet(type){
    this.tenantService.wallet = type;
    this.tenantService.setTenant(this.tenant);
    this.modal(TenantWalletComponent, 'modal-basic-title', 'lg', true, 'static');
  }
  editTenant(row) {
    this.tenantService.setTenant(row);
    this.tenantService.edit = true;
    this.modal(TenantAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  printerTenant(row): void {
    this.tenantService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.tenantService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') { this.router.navigate(['/admin/locataire']) }
        });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => {

    }, (reason) => {

    });
  }
  showFile(item) {
    const fileByFolder = this.uploader.getDataFileByFolder();
    this.file = fileByFolder?.path ? this.publicUrl + '/' + fileByFolder?.path : null;
  }
  closeViewer() {
    this.file = '';
    this.uploader.setDataFileByFolder('');
  }
  back() { this.router.navigate(['/admin/locataire']) }
}
